import { KeyValue } from '../../common/redux/api/web-api'
import findOcppConfig from '../findOcppConfig'

export function getConfigValue(
    key: string,
    configKeys: Array<KeyValue> | null | undefined,
    connectorId?: number
): string | null {
    const value = findOcppConfig(key, configKeys)
    if (value === null || value === undefined) {
        return null
    }

    return connectorId ? value.split(',')[connectorId - 1]?.replace(`${connectorId}.`, '') : value
}
